import type { FileType } from "@/types/FileType";

export const documentSign: FileType = {
  title: "sign.p7s",
  format: "application/pkcs7-signature",
};
